/**
 * Analytics Tracking for Lead/Conversion Events
 * Detects customer registration/login events and sends them to Google Analytics
 * Supports both Google Analytics 4 (gtag) and Google Tag Manager (dataLayer)
 */

(function() {
  'use strict';

  // Check if customer has just completed registration or login
  const urlParams = new URLSearchParams(window.location.search);
  const isCustomerPosted = urlParams.get('customer_posted') === 'true';

  // If customer_posted is not true, don't send event
  if (!isCustomerPosted) {
    return;
  }

  // Helper function to safely send events with multiple fallback options
  function sendLeadEvent() {
    // Method 1: Google Analytics 4 via gtag
    if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
      try {
        // Send lead event to Google Ads
        gtag('event', 'lead', {
          'currency': 'BRL',
          'value': 0
        });

        // Send conversion event for Google Analytics 4
        gtag('event', 'user_signup', {
          'method': 'account_registration'
        });

        console.log('[Analytics] Lead event sent via gtag');
      } catch (error) {
        console.warn('[Analytics] Error sending gtag event:', error);
      }
    }

    // Method 2: Google Tag Manager via dataLayer
    if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
      try {
        window.dataLayer.push({
          'event': 'lead',
          'eventCategory': 'user',
          'eventAction': 'registration',
          'eventLabel': 'customer_signup',
          'currency': 'BRL',
          'value': 0
        });

        window.dataLayer.push({
          'event': 'user_signup',
          'method': 'account_registration'
        });

        console.log('[Analytics] Lead event sent via dataLayer (GTM)');
      } catch (error) {
        console.warn('[Analytics] Error sending dataLayer event:', error);
      }
    }

    // Method 3: Fallback - wait for gtag to be available (for delayed GA loading)
    if (typeof gtag === 'undefined') {
      // Set up observer for gtag becoming available
      let attempts = 0;
      const maxAttempts = 20; // Check for 10 seconds (20 * 500ms)
      
      const checkGtag = setInterval(function() {
        attempts++;
        
        if (typeof gtag !== 'undefined' && typeof gtag === 'function') {
          clearInterval(checkGtag);
          try {
            gtag('event', 'lead', {
              'currency': 'BRL',
              'value': 0
            });
            gtag('event', 'user_signup', {
              'method': 'account_registration'
            });
            console.log('[Analytics] Lead event sent via delayed gtag');
          } catch (error) {
            console.warn('[Analytics] Error sending delayed gtag event:', error);
          }
        }
        
        if (attempts >= maxAttempts) {
          clearInterval(checkGtag);
          console.warn('[Analytics] gtag not available after 10 seconds');
        }
      }, 500);
    }
  }

  // Send the event when DOM is ready or immediately if already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sendLeadEvent);
  } else {
    // Use setTimeout to ensure GA is fully loaded
    setTimeout(sendLeadEvent, 100);
  }
})();
